import Script from 'next/script';
import {useAccountDetailsQuery, useCurrentUserQuery, useRealUserQuery} from "@graphql/generated-graphql";
import {getClient} from "@graphql/graphql-client/graphClient";
import {useEffect} from "react";

/**
 * This needs to be moved to the AWS Environment/Config or Github
 */

export function ScriptHeader() {
    const realUser = useRealUserQuery(getClient('users'))?.data?.realMe;
    const user = useCurrentUserQuery(getClient('users'))?.data?.me;
    const { data: accountData } = useAccountDetailsQuery(getClient('users'));

    useEffect(() => {
        const intercomConfig = {
            api_base: "https://api-iam.intercom.io",
            app_id: process.env.NEXT_PUBLIC_INTERCOM_APPID,
            name: realUser?.fullName,
            email: realUser?.email,
            next_internal_id: realUser?.id,
            user_id: realUser?.uid,
            user_hash: realUser?.intercomHash
        } as any;
        if (realUser && user && accountData?.account && realUser.id == user.id) {
            intercomConfig.subscription_plan = accountData?.account?.subscriptionPlan?.title;
        }
        // @ts-ignore
        if (window.Intercom?.booted) {
            // @ts-ignore
            const wasLoggedIn = window.intercomSettings?.user_id;
            // @ts-ignore
            window.intercomSettings = intercomConfig;
            if (wasLoggedIn) {
                // @ts-ignore
                window.Intercom('shutdown');
                // @ts-ignore
                setTimeout(() => window.Intercom('boot'), 1000);
            } else
                // @ts-ignore
                window.Intercom('update', intercomConfig);
        } else {
            // @ts-ignore
            window.intercomSettings = intercomConfig;
            // @ts-ignore
            if (window.Intercom) window.Intercom('boot', intercomConfig);
        }
    }, [realUser, user, accountData]);

    return <>
        {process.env.NEXT_PUBLIC_INTERCOM_APPID && (realUser || !user) &&
            <Script id="intercom-integration">
                {`
                    window.intercomSettings = {
                    api_base: "https://api-iam.intercom.io",
                    app_id: ${JSON.stringify(process.env.NEXT_PUBLIC_INTERCOM_APPID)},
                    name: ${JSON.stringify(realUser?.fullName)},
                    email: ${JSON.stringify(realUser?.email)},
                    next_internal_id: ${JSON.stringify(realUser?.id)},
                    user_id: ${JSON.stringify(realUser?.uid)},
                    user_hash: ${JSON.stringify(realUser?.intercomHash)}
                };
                (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${process.env.NEXT_PUBLIC_INTERCOM_APPID}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();        
                `}
            </Script>}

        <Script id="clarity-integration">
            {`(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${process.env.NEXT_PUBLIC_CLARITY_APP_ID || 'lf315c88bl'}");`}
        </Script>

        {realUser && user && <Script id="clarity-identification">
            {`window.clarity("identify", ${JSON.stringify(user.id)}, undefined, undefined, ${JSON.stringify(user.fullName)});`}
            {`window.clarity("set", "Original Name", ${JSON.stringify(realUser.fullName)});`}
            {`window.clarity("set", "User Name", ${JSON.stringify(user.fullName)});`}
            {`window.clarity("set", "Email", ${JSON.stringify(user.email)});`}
        </Script>}
    </>
}
